import React, { useMemo } from 'react';
import { formatDateTime } from '../../../config/appConfig';
import { cn } from '../../../lib/utils';
import { ReportSheetFooter } from '../../../components/ui/Report';

type MgaReportRootProps = {
  className?: string;
  children: React.ReactNode;
  /** When false, omit the sheet footer (rare). Default true. */
  showFooter?: boolean;
  pageNumber?: number;
  pageCount?: number;
};

/** MGA printable article with shared Date/Time + Page X of N footer. */
export const MgaReportRoot: React.FC<MgaReportRootProps> = ({
  className,
  children,
  showFooter = true,
  pageNumber = 1,
  pageCount = 1,
}) => {
  const printedAt = useMemo(() => formatDateTime(new Date()), []);
  return (
    <article className={cn('app-print-root mga-report mga-report-with-footer', className)}>
      <div className="mga-report-body">{children}</div>
      {showFooter ? (
        <ReportSheetFooter
          pageNumber={pageNumber}
          pageCount={pageCount}
          printedAt={printedAt}
        />
      ) : null}
    </article>
  );
};

export default MgaReportRoot;
